// import { toast } from 'react-toastify';

// const ToastCommon = {
//     success: (message) => {
//         toast.success(message);
//     },
//     warning: (message) => {
//         toast.warn(message); // ✅ Changed to `warn` (consistent with react-toastify)
//     },
//     error: (message) => {
//         toast.error(message); // ✅ Changed `danger` → `error` (standard naming)
//     },
//     info: (message) => {
//         toast.info(message); // ✅ Added `info` as an optional notification type
//     }
// };

// export { ToastCommon };


// helpers/ToastCommon.js
import { toast } from "sonner";

const ToastCommon = {
    success: (message) => toast.success(message),
    warning: (message) => toast.warning(message),
    error: (message) => toast.error(message),
    info: (message) => toast(message), // Sonner uses `toast()` for info
};

export { ToastCommon };
